import { Component, OnInit } from "@angular/core";
import { AppService } from "src/app/core/services/app.service";
import { DealerService } from "src/app/core/services/dealer.service";
import { FocuslinkService } from "src/app/core/services/focuslink.service";
import { UserService } from "src/app/core/services/user.service";
import { OOVenueService } from "src/app/core/services/venue-service";
import { UserRoleEnum } from "src/app/shared/models/enums/user-role.enum";
import { Store } from "src/app/shared/models/store";

@Component({
	selector: "app-dealers",
	templateUrl: "./dealers.component.html",
	styleUrls: ["../commandcenter.scss"],
})
export class DealersComponent implements OnInit {
	displayDealerSelect: boolean;
	selectedDealerKey: string;

	dealerVenue: Store[];

	onlineOrderVenueCount: number;

	venueSelected: Store;

	constructor(
		public app: AppService,
		private focuslink: FocuslinkService,
		public dealerService: DealerService,
		public userService: UserService,
		public venueService: OOVenueService
	) {}

	ngOnInit(): void {
		if (
			this.userService.user?.dealerKey &&
			!this.dealerService.dealer.value.key &&
			(this.userService.user.role === UserRoleEnum.DEALERADMIN || this.userService.user.role === UserRoleEnum.DEALERUSER)
		) {
			this.dealerService.initDealer(this.userService.user.dealerKey);
		}

		if (
			!this.dealerService.dealer.value.key &&
			(this.userService.user?.role === UserRoleEnum.GOD || this.userService.user?.role === UserRoleEnum.SUPERADMIN)
		) {
			this.dealerService.dealerListGet();
			this.displayDealerSelect = true;
		}

		if (!this.userService.user) {
			this.userService.userSubscription.subscribe((user) => {
				if (!this.dealerService.dealer.value.key && (user.role === UserRoleEnum.GOD || user.role === UserRoleEnum.SUPERADMIN)) {
					this.dealerService.dealerListGet();
					this.displayDealerSelect = true;
				} else {
					if (!this.dealerService.dealer.value.key && (user.role === UserRoleEnum.DEALERADMIN || user.role === UserRoleEnum.DEALERUSER)) {
						this.dealerService.initDealer(this.userService.user.dealerKey);
					}
				}
			});
		}

		this.dealerService.dealer.subscribe((dealer) => {
			this.onlineOrderVenueCount = dealer.venues?.filter((v) => v.onlineOrder).length;
		});
	}
}
